import type { TFunction } from "i18next"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import {
  VERIFY_COMPANY_OUTCOMES,
  type VerifyCompanyOutcome,
} from "~/pages/SupplierPortal/Onboarding/verifyCompanyOutcome/verifyCompanyOutcome.types"

export type VerifyCompanyOutcomeOption = Readonly<{
  outcome: VerifyCompanyOutcome
  label: string
  description: string
}>

const toTranslatedOutcomeOption = (
  outcome: VerifyCompanyOutcome,
  t: TFunction<"supplier">
): VerifyCompanyOutcomeOption => {
  switch (outcome) {
    case "claim_company":
      return {
        outcome,
        label: t("onboarding.verifyCompany.outcomes.claim_company.label"),
        description: t(
          "onboarding.verifyCompany.outcomes.claim_company.description"
        ),
      }
    case "answer_on_behalf":
      return {
        outcome,
        label: t("onboarding.verifyCompany.outcomes.answer_on_behalf.label"),
        description: t(
          "onboarding.verifyCompany.outcomes.answer_on_behalf.description"
        ),
      }
    case "not_related":
      return {
        outcome,
        label: t("onboarding.verifyCompany.outcomes.not_related.label"),
        description: t(
          "onboarding.verifyCompany.outcomes.not_related.description"
        ),
      }
  }
}

export const useVerifyCompanyOutcomeOptions =
  (): readonly VerifyCompanyOutcomeOption[] => {
    const { t } = useTranslation("supplier")

    return useMemo(
      () =>
        VERIFY_COMPANY_OUTCOMES.map((outcome) =>
          toTranslatedOutcomeOption(outcome, t)
        ),
      [t]
    )
  }
